<template>
	<div class="container" ref="editorContainer">
		<fullscreen ref="fullscreen" @change="fullscreenChange">
			<i @click="gofullScreen()" class="el-icon-rank fullScreen"></i>
			<editor
				style="border-radius: 4px; border: 1px solid #dcdfe6"
				v-model="localJavascript"
				@init="editorInit"
				lang="javascript"
				:theme="theme === 'Light' ? 'chrome' : 'tomorrow_night_blue'"
				:height="fullscreen ? '100%' : '50vh'"
				:width="fullscreen ? '100%' : '99%'"
				class="javascriptEditor"
				ref="javascriptEditor"
			></editor>
		</fullscreen>
	</div>
</template>

<script>
import editor from "vue2-ace-editor";
import beautify from "js-beautify";
import { mapGetters, mapActions } from "vuex";
import { v4 as uuidv4 } from "uuid";
export default {
	props: {
		code: String,
	},
	components: {
		editor,
	},
	computed: {
		...mapGetters(["returnReferencePath", "returnLastFocusedVariableInsertionInput"]),
	},
	data() {
		return {
			componentId: uuidv4(),
			showMethods: false,
			localJavascript: "",
			fullscreen: false,
			theme: "Dark",
			codeMounted: false,
			editor: null,
			globalPrefix: "",
		};
	},
	watch: {
		localJavascript(state) {
			if (this.codeMounted) {
				this.$emit("codeMutation", state);
			} else {
				this.codeMounted = true;
			}
		},
		returnReferencePath: function () {
			if (this.returnLastFocusedVariableInsertionInput === this.componentId) {
				this.editor.session.insert(this.editor.getCursorPosition(), `'{{${this.returnReferencePath.path}}}'`);
				this.editor.focus();
			}
		},
	},
	beforeMount() {
		this.localJavascript = beautify(this.code, { indent_size: 2, space_in_empty_paren: true });
	},
	methods: {
		...mapActions(["updateLastFocusedVariableInsertionInputMETHOD"]),
		editorInit(editor) {
			const $this = this;
			this.editor = editor;
			require("brace/ext/language_tools");
			require("brace/theme/twilight");
			require("brace/theme/tomorrow_night_blue");
			require("brace/mode/javascript");
			require("brace/theme/chrome");
			require("brace/theme/monokai");
			let editorTextAreas = document.querySelectorAll(".javascriptEditor .ace_text-input");
			let $trigger = false;
			const globalVarsCompleter = {
				getCompletions: function (editor, session, pos, prefix, callback) {
					if (!$trigger) {
						return;
					}
					callback(null, [
						{
							caption: "$inputData",
							value: "$inputData",
						},
						{
							caption: "returnOutputData",
							value: "returnOutputData();",
						},
						{
							caption: "log",
							value: "log();",
						},
					]);
					const popup = editor.completer.popup;
					popup.container.style.maxWidth = "180px";
					popup.resize();
				},
			};
			editorTextAreas.forEach((editor, i) => {
				editor.addEventListener("focus", () => {
					$this.updateLastFocusedVariableInsertionInputMETHOD($this.componentId);
					document.getElementsByClassName("javascriptEditor")[i].classList.add("focusInput");
				});
				editor.addEventListener("blur", () => {
					document.getElementsByClassName("javascriptEditor")[i].classList.remove("focusInput");
				});
			});
			editor.setOptions({
				showPrintMargin: false,
				cursorStyle: "slim",
				enableBasicAutocompletion: true,
				enableSnippets: false,
				enableLiveAutocompletion: true,
			});
			editor.completers = [globalVarsCompleter];
			editor.commands.addCommand({
				name: "detectDollarSign",
				bindKey: { win: "$", mac: "$" },
				exec: function (editor) {
					$trigger = true;
					editor.insert("$");
					editor.commands.byName.startAutocomplete.exec(editor);
				},
			});
			/* editor.commands.addCommand({
				name: "detectDot",
				bindKey: { win: ".", mac: "." },
				exec: function (editor) {
					editor.insert(".");
					$this.automcompleteIs = "sessionProperties";
					editor.commands.byName.startAutocomplete.exec(editor);
				},
			}); */
		},
		gofullScreen() {
			this.$refs["fullscreen"].toggle();
		},
		fullscreenChange(fullscreen) {
			this.fullscreen = fullscreen;
		},
	},
};
</script>

<style scoped>
.container {
	position: relative;
	display: block;
}
.container /deep/ .ace_editor {
	border-radius: 4px !important;
	border: 1px solid #dcdfe6;
}
.container /deep/ .focusInput {
	border: 1px solid #210f3c !important;
}

.fullScreen {
	transform: rotate(47deg);
	right: 10px;
	color: white;
	bottom: 10px;
	cursor: pointer;
	position: absolute;
	z-index: 100;
	font-size: 15px;
	background-color: #2b3a67;
	border-radius: 50%;
	padding: 5px;
}
</style>
